<template lang="pug">
div
  ValidationProvider(
    v-slot="{ errors }"
    name="projects"
    :model-value="allProjects"
  )
    #projects.form-group(:class="{ 'has-error': errors[0] }")
      AppMembersSelector(
        ref="members-user-selector"
        :organization-id="organizationId"
        :resource="resource"
        :resource-id="clientId"
        :placeholder="placeholderText"
        :records="['projects']"
        search-placeholder="Search projects"
        records-name="projects"
        title="Projects"
        submit-button-label="Done"
        multiple
        sortable
        show-select-all-trigger
        @submit-selections="updateProjectSelection"
      )
        template(#title="")
          label.control-label Projects / work orders
      span.help-block {{ errors[0] }}
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { getProjectFlavourLabel } from '~/utils/project_flavour';
import { ClientsResource } from '~/resources';

export default {
  name: 'ClientDialogTabProjects',
  data() {
    return {
      defaultSelect2Options: {
        allowClear: true,
        multiple: true,
        width: '100%',
      },
    };
  },
  computed: {
    ...mapState({
      organizationId: (state) => state.organization.id,
      isNewForm: (state) => state.isNewForm,
      clientId: (state) => state.client.id,
    }),
    ...mapGetters(['projectOptions', 'allProjects', 'projectsVisible', 'workOrdersVisible']),
    select2Options() {
      return { ...this.defaultSelect2Options, ...{ placeholder: this.placeholderText } };
    },
    projectsLabelText() {
      if (this.projectsVisible && this.workOrdersVisible) {
        return getProjectFlavourLabel('both', true);
      }
      if (this.workOrdersVisible) {
        return getProjectFlavourLabel('work_orders', true);
      }

      return getProjectFlavourLabel('projects', true);
    },
    placeholderText() {
      return `Select ${this.projectsLabelText.toLowerCase()}`;
    },
    resource() {
      return ClientsResource.projects;
    },
  },
  methods: {
    ...mapActions(['updateProjects']),
    async updateProjectSelection({ members, options = { select_all: false, clear_all: false } }) {
      this.updateProjects({ members, options, isNewForm: this.isNewForm });
    },
  },
};
</script>
